import gql from "graphql-tag";

export const ACTIVITY_PARENT_TYPE_CHOICES = gql`
    query ActivityParentTypeChoices {
        activityParentTypeChoices {
            choices
        }
    }
`;

export const ACTIVITY_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query ActivityShareCategoryTypeChoices {
        activityShareCategoryTypeChoices {
            choices
        }
    }
`;

export const ACTIVITY_STATUS_CHOICES = gql`
    query ActivityStatusChoices {
        activityStatusChoices {
            choices
        }
    }
`;

export const CONTACT_LIST_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query ContactListShareCategoryTypeChoices {
        contactListShareCategoryTypeChoices {
            choices
        }
    }
`;

export const CONTACT_LIST_TYPE_CHOICES = gql`
    query ContactListTypeChoices {
        contactListTypeChoices {
            choices
        }
    }
`;

export const EMAIL_ADDRESS_PARENT_TYPE_CHOICES = gql`
    query EmailAddressParentTypeChoices {
        emailAddressParentTypeChoices {
            choices
        }
    }
`;

export const EMAIL_ADDRESS_TYPE_CHOICES = gql`
    query EmailAddressTypeChoices {
        emailAddressTypeChoices {
            choices
        }
    }
`;

export const FILTER_TYPE_CHOICES = gql`
    query FilterTypeChoices {
        filterTypeChoices {
            choices
        }
    }
`;

export const INTRODUCTION_DIRECTION_CHOICES = gql`
    query IntroductionDirectionChoices {
        introductionDirectionChoices {
            choices
        }
    }
`;

export const KEYWORD_LINK_PARENT_TYPE_CHOICES = gql`
    query KeyworkLinkParentTypeChoices {
        keyworkLinkParentTypeChoices {
            choices
        }
    }
`;

export const MAIL_ADDRESS_PARENT_TYPE_CHOICES = gql`
    query MailAddressParentTypeChoices {
        mailAddressParentTypeChoices {
            choices
        }
    }
`;

export const MAIL_ADDRESS_TYPE_CHOICES = gql`
    query MailAddressTypeChoices {
        mailAddressTypeChoices {
            choices
        }
    }
`;

export const NEWS_TYPE_CHOICES = gql`
    query NewsTypeChoices {
        newsTypeChoices {
            choices
        }
    }
`;

export const NOTE_PARENT_TYPE_CHOICES = gql`
    query NoteParentTypeChoiced {
        noteParentTypeChoices {
            choices
        }
    }
`;

export const NOTE_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query NoteShareCategoryTypeChoices {
        noteShareCategoryTypeChoices {
            choices
        }
    }
`;

export const PHONE_NUMBER_PARENT_TYPE_CHOICES = gql`
    query PhoneNumberParentTypeChoices {
        phoneNumberParentTypeChoices {
            choices
        }
    }
`;

export const PHONE_NUMBER_TYPE_CHOICES = gql`
    query PhoneNumberTypeChoices {
        phoneNumberTypeChoices {
            choices
        }
    }
`;

export const PROJECT_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query ProjectShareCategoryTypeChoices {
        projectShareCategoryTypeChoices {
            choices
        }
    }
`;

export const SHARE_AREA_RULE_CHOICES = gql`
    query ShareAreaRuleChoices {
        shareAreaRuleChoices {
            choices
        }
    }
`;

export const SHARE_RULE_PARENT_TYPE_CHOICES = gql`
    query ShareRuleParentTypeChoices {
        shareRuleParentTypeChoices {
            choices
        }
    }
`;

export const SHARE_RULE_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query ShareRuleShareCategoryTypeChoices {
        shareRuleShareCategoryTypeChoices {
            choices
        }
    }
`;

export const SPECIALTY_LINK_PARENT_TYPE_CHOICES = gql`
    query SpecialtyLinkParentTypeChoices {
        specialtyLinkParentTypeChoices {
            choices
        }
    }
`;

export const TAG_LINK_PARENT_TYPE_CHOICES = gql`
    query TagLinkParentTypeChoices {
        tagLinkParentTypeChoices {
            choices
        }
    }
`;

export const TASK_PARENT_TYPE_CHOICES = gql`
    query TaskParentTypeChoices {
        taskParentTypeChoices {
            choices
        }
    }
`;

export const TASK_SHARE_CATEGORY_TYPE_CHOICES = gql`
    query TaskShareCategoryTypeChoices {
        taskShareCategoryTypeChoices {
            choices
        }
    }
`;
